<template>
  <div id="app">
    <Header></Header>

    <Page imgSrc="img/schlosserei-raichle-team.jpg">
      <div class="pb-8 px-content">
        <h2 class="subheadline">Stellenauschreibung</h2>
        <div class="flex justify-center">
          <h1 class="headline">Metallbauer (m/w/d) in Dettingen unter Teck</h1>
        </div>

        <p>
          Du hast Lust in einem familiären Umfeld mit motivierten Kollegen an
          interessanten Stahl- und Metallbauarbeiten zu arbeiten? Dann bist Du
          bei uns genau richtig!
        </p>
        <p>
          Wir sind ein Familienunternehmen aus dem Raum Kirchheim unter Teck.
          Unsere Schlosserei gibt es schon seit 1865 und wird in der sechsten
          Generation von Christian Raichle geleitet. Wir haben ein junges
          motiviertes Team mit dem wir unsere Bauprojekte umsetzen.
        </p>
        <p>
          Wir suchen einen <strong>Metallbauer (m/w/d)</strong>, der uns beim
          Anfertigen und Montieren von Stahl- und Metallbauarbeiten unterstützt.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2">
          Ein paar gute Gründe, warum du dich bei uns bewerben solltest:
        </h2>
        <ul class="list-none benefits">
          <li class="handshake">
            Arbeiten in einem guten Betriebsklima mit einem jungen,
            aufgeschlossenen Team
          </li>
          <li class="screw">
            Abwechslungsreiche Arbeit in Produktion und Montage
          </li>
          <li class="home">Baustellen in der nahen Umgebung</li>
          <li class="secure">Unbefristeter Arbeitsvertrag</li>
          <li class="calendar">4 Tage Woche - 37 Wochenstunden</li>
          <li class="shirt">Arbeitskleidung wird Dir gestellt</li>
          <li class="coffee">Kaffee, Wasser & Saft gibt’s gratis</li>
        </ul>
        <!-- was du bietest? -->

        <p>Haben wir Dein Interesse geweckt?</p>
        <p>
          Dann bewerbe Dich jetzt ganz unkompliziert bei uns. Kein Anschreiben,
          kein Lebenslauf, nur ein paar Klicks & wir melden uns bei Dir.
        </p>

        <div class="top_of_form"></div>

        <div v-if="!form_sent">
          <div class="w-full text-2xl text-center">👇</div>
          <h2 class="text-3xl text-center font-semibold mt-1 mb-4">
            Jetzt bewerben
          </h2>
          <form class="w-full" v-on:submit.prevent="checkForm">
            <SectionHeader
              title="Hast du eine Metallbauer Ausbildung?"
            ></SectionHeader>
            <div class="flex flex-wrap -mx-3 mb-6">
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="ausbildung"
                value="Ja"
                v-model="form.hat_ausbildung"
              >
              </RadioButton>
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="ausbildung"
                value="Nein"
                v-model="form.hat_ausbildung"
                :errorMsg="errors.hat_ausbildung"
              >
              </RadioButton>
            </div>
            <SectionHeader
              title="Wieviel Berufserfahrung hast Du?"
            ></SectionHeader>
            <div class="flex flex-wrap -mx-3 mb-6">
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="berufserfahrung"
                value="0-2 Jahre"
                v-model="form.berufserfahrung"
              >
              </RadioButton>
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="berufserfahrung"
                value="2-5 Jahre"
                v-model="form.berufserfahrung"
              >
              </RadioButton>
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="berufserfahrung"
                value="5-10 Jahre"
                v-model="form.berufserfahrung"
              >
              </RadioButton>
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="berufserfahrung"
                value=">10 Jahre"
                v-model="form.berufserfahrung"
              >
              </RadioButton>
            </div>
            <SectionHeader title="Hast Du einen Führerschein?"></SectionHeader>
            <div class="flex flex-wrap -mx-3 mb-6">
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="fuehrerschein"
                value="Ja"
                v-model="form.hat_fuehrerschein"
              >
              </RadioButton>
              <RadioButton
                class="w-full md:w-1/2 px-3 mb-0"
                group="fuehrerschein"
                value="Nein"
                v-model="form.hat_fuehrerschein"
              >
              </RadioButton>
            </div>
            <SectionHeader
              title="Wie können wir Dich erreichen?"
            ></SectionHeader>
            <div class="flex flex-wrap -mx-3 mb-6">
              <Textfield
                class="w-full px-3"
                title="Name"
                placeholder="Dein Vor- und Nachname"
                v-model="form.name"
                :errorMsg="errors.name"
              >
              </Textfield>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <Textfield
                class="w-full md:w-1/2 px-3 mb-6 md:mb-0"
                title="Email"
                placeholder="Deine Email Adresse"
                v-model="form.email"
                :errorMsg="errors.email"
              >
              </Textfield>
              <Textfield
                class="w-full md:w-1/2 px-3"
                title="Telefonnummer"
                placeholder="Deine Telefonnummer"
                v-model="form.phone"
                :errorMsg="errors.phone"
              >
              </Textfield>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <Checkbox
                class="w-full px-3 mb-6 md:mb-0"
                option_text="Ich bin damit einverstanden, dass meine Daten im Rahmen der Bewerbung zur Kontaktaufnahme verwendet und verarbeitet werden."
                trueValue="Ja"
                falseValue="Nein"
                v-model="form.kontaktaufnahme_ok"
                :errorMsg="errors.kontaktaufnahme_ok"
              >
              </Checkbox>
            </div>
            <input
              type="submit"
              class="
                w-full
                shadow
                bg-brand-yellow
                border-brand-yellow
                hover:border-brand-blue
                border-2
                focus:shadow-outline focus:outline-none
                text-white
                font-bold
                py-2
                px-4
                rounded
                text-brand-blue
              "
              value="Bewerbung absenden"
            />
          </form>
        </div>
        <div v-else>
          <div v-if="!form_sent_error">
            <div class="w-full text-2xl text-center">👍</div>
            <h2 class="text-3xl text-center font-semibold mt-1 mb-4">
              Vielen Dank für Deine Bewerbung
            </h2>
            <p>
              Wir melden uns in den nächsten Tagen bei Dir. Bei Rückfragen
              kannst Du uns unter
              <a href="mailto:info@schlosserei-raichle.de" class="link"
                >info@schlosserei-raichle.de</a
              >
              oder per Telefon unter
              <a class="link" href="tel:00490702181516">07021 / 81516</a>
              erreichen.
            </p>
            <p>
              Schöne Grüße,<br />
              Christian Raichle
            </p>
            <div class="relative pb-2/3 mt-6">
              <Picture
                src="img/chris_frieder_raichle.jpg"
                alt="Christian und Frieder Raichle"
                imgClass="absolute object-cover h-full w-full"
              />
            </div>
          </div>
          <div v-else>
            <div class="w-full text-2xl text-center">🙈</div>
            <h2 class="text-3xl text-center font-semibold mt-1 mb-4">
              Sorry da ist was schief gegangen
            </h2>
            <p>
              Vielen Dank für Deine Bewerbung, leider ist bei der Übertragung
              was schief gegangen. Bitte sende Deine Infos an
              <a href="mailto:info@schlosserei-raichle.de" class="link"
                >info@schlosserei-raichle.de</a
              >.
            </p>

            <p class="bg-gray-200 py-2 px-4">
              {{ form }}
            </p>

            <p>
              Wir melden uns dann bei Dir. Bei Rückfragen kannst Du uns unter
              <a href="mailto:info@schlosserei-raichle.de" class="link"
                >info@schlosserei-raichle.de</a
              >
              oder per Telefon unter
              <a class="link" href="tel:00490702181516">07021 / 81516</a>
              erreichen.
            </p>
            <p>
              Schöne Grüße,<br />
              Christian Raichle
            </p>
            <div class="relative pb-2/3 mt-6">
              <Picture
                src="img/chris_frieder_raichle.jpg"
                alt="Christian und Frieder Raichle"
                imgClass="absolute object-cover h-full w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="mb-12"></div>

      <CallToAction></CallToAction>
    </Page>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CallToAction from "../components/CallToAction.vue";
import Textfield from "../components/form/Textfield.vue";
import Checkbox from "../components/form/Checkbox.vue";
import RadioButton from "../components/form/RadioButton.vue";
import Page from "../components/Page.vue";
import SectionHeader from "./SectionHeader.vue";
import Picture from "../components/Picture.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    Textfield,
    Checkbox,
    RadioButton,
    SectionHeader,
    Picture,
  },
  data() {
    return {
      form: {
        hat_ausbildung: "",
        name: "",
        email: "",
        phone: "",
        kontaktaufnahme_ok: "Nein",
        berufserfahrung: "0-2 Jahre",
        hat_fuehrerschein: "Ja",
      },
      errors: {
        hat_ausbildung: null,
        name: null,
        email: null,
        kontaktaufnahme_ok: null,
        berufserfahrung: null,
        hat_fuehrerschein: null,
      },
      form_sent: false,
      form_sent_error: false,
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/" + pic);
    },
    checkForm() {
      var hasErrors = false;

      var keys = Object.keys(this.errors);
      for (var i = 0; i < keys.length; i++) {
        // use val
        this.errors[keys[i]] = null;
      }

      if (this.form.hat_ausbildung !== "Ja") {
        this.errors.hat_ausbildung =
          "Eine Ausbildung ist für diese Stelle notwendig.";
        this.scrollToTopOfForm();
        hasErrors = true;
      }
      if (this.isEmpty(this.form.name)) {
        this.errors.name = "Bitte gib Deinen Namen an";
        hasErrors = true;
      }
      if (this.isEmpty(this.form.email)) {
        this.errors.email = "Bitte gib Deine Email an.";
        hasErrors = true;
      }
      if (this.isEmpty(this.form.phone)) {
        this.errors.phone = "Bitte gib Deine Telefonnummer an.";
        hasErrors = true;
      }
      if (this.form.kontaktaufnahme_ok !== "Ja") {
        this.errors.kontaktaufnahme_ok =
          "Wir verwenden Deine Daten nur im Rahmen Deiner Bewerbung. Bitte gibt uns Dein OK Dich zu kontaktieren.";
        hasErrors = true;
      }

      if (!hasErrors) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.form),
        };
        fetch("/send_bewerbung.php", requestOptions)
          .then((response) => {
            if (!response.ok) {
              throw "Error " + response.status;
            } else {
              return response.json;
            }
          })
          .then(() => {
            this.form_sent_error = false;
            this.form_sent = true;
            this.scrollToTopOfForm();
          })
          .catch((err) => {
            console.log(err);
            this.form_sent_error = true;
            this.form_sent = true;
            this.scrollToTopOfForm();
          });
        this.$metaPixel.trackCustom('FormSent')
      }
    },
    isEmpty(str) {
      return !str.trim().length;
    },
    scrollToTopOfForm(options) {
      const el = this.$el.getElementsByClassName("top_of_form")[0];
      console.log(el);
      if (el) {
        el.scrollIntoView(options);
      }
    },
  },
};
</script>

<style src="../assets/css/comfortaa.css"></style>
<style src="../assets/css/styles.css"></style>
<style>
.benefits li {
  padding-top: 1em;
}
.benefits li::before {
  padding-right: 0.75rem;
}
.handshake::before {
  content: "🤝";
}
.screw::before {
  content: "🔩";
}
.home::before {
  content: "🏡";
}
.secure::before {
  content: "🔒";
}
.money::before {
  content: "💰";
}
.shirt::before {
  content: "👕";
}
.coffee::before {
  content: "☕";
}
.calendar::before {
  content: "📅"
}

.radio_wrapper input[type="radio"]:checked + label {
  color: #3490dc;
}

.radio_wrapper input[type="radio"]:focus + label {
  border-inline: 2px dashed #444;
}
</style>